import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, MailIcon, MessageCircleIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
import { salon, founder } from '../data/content';
export function Footer() {
  return <footer className="border-t border-line bg-shell" data-id="element-130" data-mp="32pp57z2flp3v">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-131" data-mp="36oo8lf8ildt7">
        {/* Newsletter */}
        <div className="grid gap-8 border-b border-line py-14 lg:grid-cols-12 lg:items-end lg:py-16" data-id="element-132" data-mp="3ueijvsd6qubc">
          <div className="lg:col-span-6" data-id="element-133" data-mp="398zqhbvha9n">
            <h2 className="font-display text-4xl font-light leading-[1.05] text-ink" data-id="element-134" data-mp="387g3ogsjfgb">
              Eén e-mail per maand,
              <span className="italic text-clay" data-id="element-135" data-mp="3lgooqkr5q6pr"> zonder aanbiedingen.</span>
            </h2>
            <p className="mt-4 max-w-md text-[15px] leading-relaxed text-muted" data-id="element-136" data-mp="3qfjhofiu9bnl">
              Een nieuwe podcastaflevering, één artikel en wat {founder.firstName} die maand in de
              salon opviel.
            </p>
          </div>
          <form className="flex flex-col gap-3 sm:flex-row lg:col-span-6" onSubmit={e => e.preventDefault()} data-id="element-137" data-mp="3l90n1twdyuy7">
            <label htmlFor="footer-email" className="sr-only" data-id="element-138" data-mp="3gca5f24xnrao">
              E-mailadres
            </label>
            <input id="footer-email" type="email" required placeholder="jouw@email.nl" className="w-full border-b border-line bg-transparent px-1 py-3 text-sm text-ink placeholder:text-muted/60 focus:border-ink focus:outline-none" data-id="element-139" data-mp="3v5n74ggw1hz6" />
            <button type="submit" className="whitespace-nowrap rounded-full bg-ink px-7 py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-140" data-mp="hstuojjf8k4q">
              Aanmelden
            </button>
          </form>
        </div>

        <div className="grid gap-12 py-14 lg:grid-cols-12 lg:py-16" data-id="element-141" data-mp="qrf67uqh6yw0">
          <div className="lg:col-span-4" data-id="element-142" data-mp="mthk50s04swu">
            <Logo className="h-12" data-id="element-143" data-mp="tv4ng298r450" />
            <p className="mt-5 max-w-sm text-[14px] leading-relaxed text-muted" data-id="element-144" data-mp="tw5yi6q9bqmq">
              Holistische huidverbetering en 100% vegan skincare in {salon.city}.
              Bindweefselmassage, cosmeceutical emerginC en eerlijk advies.
            </p>
            <div className="mt-6 flex flex-wrap gap-3" data-id="element-145" data-mp="13rg39281ic47">
              <a href="https://instagram.com" className="inline-flex items-center gap-2 rounded-full border border-line px-4 py-2 text-[13px] text-ink transition-colors duration-150 ease-soft hover:border-ink" data-id="element-146" data-mp="18ksn6z1rxuqm">
                <InstagramIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-147" data-mp="1mk1u1843bchx" />
                @beautybewust
              </a>
              <a href={salon.whatsapp} className="inline-flex items-center gap-2 rounded-full border border-line px-4 py-2 text-[13px] text-ink transition-colors duration-150 ease-soft hover:border-ink" data-id="element-148" data-mp="1rj508vvt3orh">
                <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-149" data-mp="3tcces33li2cb" />
                WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:col-span-3" data-id="element-150" data-mp="25o5c2pi4i3fu">
            <h2 className="text-[11px] uppercase tracking-widest text-muted" data-id="element-151" data-mp="25mamgxvwpn5f">Contact</h2>
            <address className="mt-5 space-y-3 text-[14px] not-italic" data-id="element-152" data-mp="21n1v1zoca1d1">
              <p className="flex gap-3 text-ink" data-id="element-153" data-mp="1worxjif56oo9">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} data-id="element-154" data-mp="1wlw2c1uoie3i" />
                <span data-id="element-155" data-mp="2tbn48m5av3jc">
                  {salon.city}
                  <br data-id="element-156" data-mp="2pdpg7mn9mnhj" />
                  Alleen op afspraak
                </span>
              </p>
              <p className="flex gap-3" data-id="element-157" data-mp="2kc0381ghfzqt">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} data-id="element-158" data-mp="2kf4gdobxe5tm" />
                <a href={`mailto:${salon.email}`} className="text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-159" data-mp="2fgazdlxfjwop">
                  {salon.email}
                </a>
              </p>
            </address>
            <p className="mt-4 text-[12px] leading-relaxed text-muted" data-id="element-160" data-mp="2ru6dlrkst9ij">{salon.responseTime}</p>
          </div>

          <div className="lg:col-span-3" data-id="element-161" data-mp="2wnr1urwlap4j">
            <h2 className="text-[11px] uppercase tracking-widest text-muted" data-id="element-162" data-mp="2ivb7efhr7zf8">Openingstijden</h2>
            <dl className="mt-5 space-y-2 text-[14px] text-muted" data-id="element-163" data-mp="2ntw6ucp6mf2m">
              {[['Di – do', '09 – 18'], ['Vrijdag', '09 – 21'], ['Zaterdag', '10 – 16'], ['Zo – ma', 'Gesloten']].map(([day, hours]) => <div key={day} className="flex justify-between gap-4 border-b border-line pb-2" data-id="element-164" data-mp="31lj3weqy7rmg">
                  <dt data-id="element-165" data-mp="36kndv7lp5tdu">{day}</dt>
                  <dd className="text-ink" data-id="element-166" data-mp="36jueirp2i65q">{hours}</dd>
                </div>)}
            </dl>
          </div>

          <nav aria-label="Footernavigatie" className="lg:col-span-2" data-id="element-167" data-mp="1q4su6lnbgho3">
            <h2 className="text-[11px] uppercase tracking-widest text-muted" data-id="element-168" data-mp="1v5qlbnqb0m1q">Ontdek</h2>
            <ul className="mt-5 space-y-2.5 text-[14px] text-muted" data-id="element-169" data-mp="1nlg03nsyjwtw">
              {[{
              to: '/behandelingen',
              label: 'Behandelingen'
            }, {
              to: '/webshop',
              label: 'Webshop'
            }, {
              to: '/journal',
              label: 'Blog & Podcast'
            }, {
              to: '/over-ons',
              label: 'Over ons'
            }].map(l => <li key={l.to} data-id="element-170" data-mp="1rocfl5n7bctm">
                  <Link to={l.to} className="transition-colors duration-150 ease-soft hover:text-ink" data-id="element-171" data-mp="13xp2m5yfhx07">
                    {l.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="flex flex-col gap-3 border-t border-line py-6 text-xs text-muted sm:flex-row sm:items-center sm:justify-between" data-id="element-172" data-mp="18xbh0ipztjal">
          <p data-id="element-173" data-mp="l660e1c8amz8">© {new Date().getFullYear()} Beauty Bewust — {salon.city}</p>
          <p className="flex gap-5" data-id="element-174" data-mp="g8xi80r2yixz">
            <a href="#privacy" className="hover:text-ink" data-id="element-175" data-mp="g7uozm6ac4ew">
              Privacy
            </a>
            <a href="#voorwaarden" className="hover:text-ink" data-id="element-176" data-mp="2ga40je8vcezy">
              Voorwaarden
            </a>
            <a href="#verzending" className="hover:text-ink" data-id="element-177" data-mp="2l7vsu9dfe34o">
              Verzending &amp; retour
            </a>
          </p>
        </div>
      </div>
    </footer>;
}